/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Pricing_Faq_7_QInputs */

const en_mk_pricing_faq_7_q = /** @type {(inputs: Mk_Pricing_Faq_7_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`How does payment work?`)
};

const id_mk_pricing_faq_7_q = /** @type {(inputs: Mk_Pricing_Faq_7_QInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bagaimana cara pembayarannya?`)
};

/**
* | output |
* | --- |
* | "How does payment work?" |
*
* @param {Mk_Pricing_Faq_7_QInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_pricing_faq_7_q = /** @type {((inputs?: Mk_Pricing_Faq_7_QInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Pricing_Faq_7_QInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_pricing_faq_7_q(inputs)
	return en_mk_pricing_faq_7_q(inputs)
});